import React from 'react';

import { IconButton } from '@mui/material';

import { useAppSelector } from 'state/hooks';
import { selectTimelineMetric } from 'state/workflowSlice';

import { LegendType } from 'appTypes';
import { classNames } from 'features/common/utils';
import { possibleMetricNames as detourMetrics } from 'features/workflow_detour/DetourTaskBar/DetourMetricsOption';
import { metricNames as timelineMetrics } from 'features/workflow_timeline/TimelineMetricsOption';
import { LegendStops } from 'features/workflow_timeline/metricsOptions';

import FontAwesomeIcon from '../common/FontAwesomeIcon';
import { LegendSlider } from './LegendSlider';

import styles from './MapMetricLegend.module.css';

const metricNameMapping = { ...timelineMetrics, ...detourMetrics };

export function LegendBar({
  title,
  setShowSettings,
}: {
  title: string;
  setShowSettings: (val: boolean) => void;
}) {
  return (
    <div className={styles.legend_bar}>
      <span className={styles.legend_title}>{title} [%]</span>
      <span className={styles.legend_button}>
        <IconButton
          size="small"
          title="Close"
          disabled={!setShowSettings}
          onClick={() => setShowSettings(true)}
        >
          <FontAwesomeIcon name="ellipsis-vertical" type="solid" />
        </IconButton>
      </span>
    </div>
  );
}

function VolumeThickness() {
  return (
    <div className={styles.volume_thickness_container}>
      <div className={styles.volume_thickness_labels}>
        <span>Low volume</span>
        <span>High volume</span>
      </div>
      <div className={styles.volume_thickness_lines}>
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export function MapMetricLegend({
  colors,
  title,
  stops,
  displayVolumeThickness,
  setShowSettings,
  preview = false,
  legendType,
  reversedDisplay = false,
}: {
  colors: any;
  title?: string;
  stops: LegendStops;
  displayVolumeThickness: Boolean;
  setShowSettings?: (val: boolean) => void;
  preview?: boolean;
  legendType?: LegendType;
  reversedDisplay?: boolean;
}) {
  const selectedMetric = useAppSelector(selectTimelineMetric);
  return (
    <div className={`${styles.map_legend} ${preview ? styles.preview : ''}`}>
      <LegendBar
        title={title ?? metricNameMapping[selectedMetric]}
        setShowSettings={setShowSettings}
      />
      {displayVolumeThickness && <VolumeThickness />}
      <div className={styles.legend_slider_section}>
        <LegendSlider
          colormap={colors}
          stops={stops}
          legendType={legendType}
          displayMarks
          className={classNames(
            styles.legend_slider,
            styles.legend_slider_styles,
            reversedDisplay && styles.legend_slider_reversed,
          )}
        />
      </div>
    </div>
  );
}
